var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sg-btn sg-btn-icon",class:{ 'sg-btn-icon--with-background': _vm.withBackground, active: _vm.active },on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('span',{staticClass:"sg-btn-toggle-icon-icon",class:_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }